var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.previewFile()}}}),_c('br'),_c('img',{attrs:{"src":"","height":"200","alt":"Image preview..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }